import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../components/Layout.vue'
import Home from '../views/Home.vue'
import Baogao from '../views/Baogao.vue'
import ReportPreview from '../views/ReportPreview.vue'
import AirBreathingApparatus from '../views/AirBreathingApparatus.vue'
import GasAlarmDetector from '../views/GasAlarmDetector.vue'
import GasCylinderDetection from '../views/GasCylinderDetection.vue'
import ProjectCases from '../views/ProjectCases.vue'
import News from '../views/News.vue'
import About from '../views/About.vue'
import Contact from '../views/Contact.vue'
import NewsDetail from '../views/NewsDetail.vue'
import ProjectCaseDetail from '../views/ProjectCaseDetail.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            title: '慧安检测 - 专业工业安全检测服务'
        }
    },
    {
        path: '/baogao',
        component: Layout,
        children: [
            {
                path: '',
                name: 'Baogao',
                component: Baogao,
                meta: {
                    title: '报告查询系统'
                }
            }
        ]
    },
    {
        path: '/preview',
        name: 'ReportPreview',
        component: ReportPreview,
        meta: {
            title: '报告预览'
        }
    },
    {
        path: '/air-breathing-apparatus',
        component: Layout,
        children: [
            {
                path: '',
                name: 'AirBreathingApparatus',
                component: AirBreathingApparatus,
                meta: {
                    title: '空气呼吸器检测 - 专业检测服务'
                }
            }
        ]
    },
    {
        path: '/gas-alarm-detector',
        component: Layout,
        children: [
            {
                path: '',
                name: 'GasAlarmDetector',
                component: GasAlarmDetector,
                meta: {
                    title: '气体报警仪检测 - 专业检测服务'
                }
            }
        ]
    },
    {
        path: '/gas-cylinder-detection',
        component: Layout,
        children: [
            {
                path: '',
                name: 'GasCylinderDetection',
                component: GasCylinderDetection,
                meta: {
                    title: '气瓶检测 - 专业检测服务'
                }
            }
        ]
    },
    {
        path: '/project-cases',
        component: Layout,
        children: [
            {
                path: '',
                name: 'ProjectCases',
                component: ProjectCases,
                meta: {
                    title: '项目案例 - 成功服务案例展示'
                }
            }
        ]
    },
    {
        path: '/news',
        name: 'News',
        component: News,
        meta: {
            title: '新闻资讯 - 行业动态与公司新闻'
        }
    },
    {
        path: '/news/:id',
        name: 'NewsDetail',
        component: NewsDetail,
        meta: {
            title: '新闻详情 - 慧安检测'
        }
    },
    {
        path: '/about',
        name: 'About',
        component: About,
        meta: {
            title: '关于我们 - 慧安检测'
        }
    },
    {
        path: '/contact',
        name: 'Contact',
        component: Contact,
        meta: {
            title: '联系我们 - 慧安检测'
        }
    },
    {
        path: '/project-cases/:id',
        name: 'ProjectCaseDetail',
        component: ProjectCaseDetail,
        meta: {
            title: '案例详情 - 慧安检测'
        }
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})

router.beforeEach((to, from, next) => {
    if (!to.matched.length) {
        next({ path: '/' })
        return
    }
    next()
})

export default router 